import { Stack, Typography } from "@mui/material";
import type { WorkbookFilter } from "../../../../api/types/workbookRuns.types";
import getWorkbookFilterIcon from "./getWorkbookFilterIcon";
import WorkbookDetailsField from "./WorkbookDetailsField";
import WorkbookFilterValue from "./WorkbookFilterValue";

interface Props {
  workbookFilters: WorkbookFilter[];
}

const WorkbookFilters = ({ workbookFilters }: Props) => {
  return (
    <Stack>
      <Typography variant="h6" sx={{ py: 2 }}>
        Workbook Filters
      </Typography>
      <Stack spacing={0.5}>
        {workbookFilters.map((filter) => (
          <WorkbookDetailsField
            key={filter.id}
            Icon={getWorkbookFilterIcon(filter)}
            fieldName={filter.name ?? ""}
            FieldValue={<WorkbookFilterValue filter={filter} />}
          />
        ))}
      </Stack>
    </Stack>
  );
};

export default WorkbookFilters;
